import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { arrowLeft, logo, not_found } from "../assets";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-center items-center gap-5">
      <img
        src={not_found}
        alt="foxseeproxy logo"
        className="w-[90%] max-w-[400px]"
      />

      <div
        className="px-4 py-2 bg-primary rounded-lg text-white shadow-lg hover:bg-secondary cursor-pointer"
        onClick={() => navigate("/")}
      >
        Back to home
      </div>
    </div>
  );
};

export default NotFound;
